module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEqADAAQAAAABAAAAEgAAAACaqbJVAAAAkklEQVQ4EWNgGLkgLS2NlRjfM+JT5Ovra/rv379tQDVnuLi4glavXv0dl3qcBoEM+fv3726gRn6QZkZGxr1Aw3xxGYbVIHRDYK7AZxiGQbgMIWQYikGEDMFnGNwgYg3BZRgTSMLPz08FOWBhivHR////d/727dtqmBqwQUBBQWBAEpVeYBpBNFCfGDJ/lD3UQgAAciFJB/7dUYQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sales-arrow-down@2x.png
// module id = 9trG
// module chunks = 258